import React from 'react';

//form
import GenericForm from "../../forms/accountDetails/ModamilyAppAdditionalDetailsForm";

//forms
import FormHeader from "../../../form/ModamilyAppFormHeader";
import ButtonGroup from "../../../form/ModamilyAppButtonGroup";

// cosntants
import Options from "../../../../constants/formOptions";

const Religion = ({ searchPreferences, handleUpdate, selectedReligionIndexes }) => (
  <div className="searchPrefForm">
		<div className="searchPrefIncomeRangeFormContainer">
			<FormHeader text="Religion" />
			<ButtonGroup
				manualSelection={true}
				customSelected={selectedReligionIndexes}
				data={Options.religion}
				onButtonClick={(value, index) => {
					if (index > -1) {
						if(value.toLowerCase() === 'no preference') {
							searchPreferences.religion = [value.toLowerCase()]
						} else {
							const indexOfPNTS = searchPreferences.religion.indexOf('no preference');
							if ( indexOfPNTS > -1) { 
								searchPreferences.religion.splice(
									indexOfPNTS,
									1
								);
							}
							searchPreferences.religion.push(
								value.toLowerCase()
							);
						}
					} else {
						searchPreferences.religion.splice(
							searchPreferences.religion.indexOf(
								value.toLowerCase()
							),
							1
						);
					}
					handleUpdate(searchPreferences);
				}}
			/>
		</div>
	</div>
)

export default Religion;